import CityPageTemplate from "../city-template/CityPageTemplate";
import { baltimoreConfig } from "./data";

export default function BaltimorePage() {
  return <CityPageTemplate config={baltimoreConfig} />;
}